import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../services/auth.service";
import { AuthGuardService } from "./auth.guard";
import { RolesUsuario } from "../enumeraciones/roles-usuario.enum";
import { TipoPrestador } from "../enumeraciones/tipo-prestador.enum";
import { isArray } from "util";

@Injectable()
export class RolGuardService implements CanActivate {
  constructor(public authService: AuthService, public router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (next.data.rol) {
      let rol = null;
      if (this.authService.getTipoUser() !== RolesUsuario.Depositario) {
        if (isArray(next.data.rol)) {
          rol = (next.data.rol as Array<TipoPrestador>).find(
            (dato) => this.authService.getRolDetalleUser() === dato
          );
        } else {
          rol = this.authService.getRolDetalleUser() === next.data.rol;
        }
      } else {
        rol = true;
      }
      if (!rol) {
        this.router.navigate(["/pagina-no-disponible"]);
        return false;
      }
    }
    return true;
  }
}
